<app-unauth-card>
  <form [formGroup]="loginForm" (submit)="submitForm()">
    <mat-form-field>
      <mat-label>{{ 'Username' | translate }}</mat-label>
      <input type="text" matInput autofocus formControlName="username" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'Password' | translate }}</mat-label>
      <input type="password" matInput formControlName="password" required />
    </mat-form-field>
    <div class="text-center">
      <mat-icon style="vertical-align: bottom;">lock</mat-icon>
      <a routerLink="/password-reset" style="color: inherit;">{{ 'Forgot your password ?' | translate }}</a>
    </div>
    @switch (loading | async) {
      @case (false) {
        <button type="submit" mat-flat-button color="primary" class="login-button" [disabled]="loginForm.invalid">
          {{ 'Log in' | translate }}
        </button>
      }
      @case (true) {
        <button type="submit" mat-flat-button color="primary" class="login-button" disabled>
          {{ 'Logging in...' | translate }}
        </button>
      }
    }
    @if (error | async; as errorMessage) {
    <mat-error>{{ errorMessage }}</mat-error>
    }
  </form>
</app-unauth-card>
